import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const excelGeneration = (fileData, fileName) => {
  var workbook = XLSX.utils.book_new(), // excel generation
    worksheet = XLSX.utils.json_to_sheet(fileData);
  XLSX.utils.book_append_sheet(workbook, worksheet);
  XLSX.writeFile(workbook, fileName);
};

export const Helper = {
  excelGeneration,
};

export const Roles = {
  admin: "Administrator",
  employer: "Employer",
  jobSeeker: "Job Seeker",
  stm: "Support Team Member",
  groupLeader: "Group Leader",
};

export const SearchTypes = {
  network: "Network",
  jobs: "Jobs",
  message: "Message",
  connections: "Connection",
  publicResume: "Public Resume",
  privateResume: "Private Resume",
  supportTeamMember: "Support Team Member",
};

export const ActionType = {
  PostedJob: "Posted Job",
  SavedResume: "Saved Resume",
  SentMessage: "Sent Message",
  ResumeReceived: "Resume Received",
  AppliedJob: "Applied Job",
  NetworkingRequest: "Networking Request",
  SponsorshipRequest: "Sponsorship Request",
  SponsorshipNoteAdded: "Sponsorship Note Added",
  AcceptedRequest: "Accepted Request",
  DraftJob: "Draft Job",
  Active: "Active",
  InActive: "InActive",
  ResumePublished: "Public Resume Posted",
};

//Generate Pdf
export const generatePdf = (pdfHeaders, fileData, fileName, title) => {
  const imgData =
    "/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMsaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA2LjAtYzAwMiA3OS4xNjQzNTIsIDIwMjAvMDEvMzAtMTU6NTA6MzggICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMS4xIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpDRUVCOTYxMkM0RjkxMUVCQUVCNkVGMzhBQTc4OUE5NSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpDRUVCOTYxM0M0RjkxMUVCQUVCNkVGMzhBQTc4OUE5NSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkNFRUI5NjEwQzRGOTExRUJBRUI2RUYzOEFBNzg5QTk1IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkNFRUI5NjExQzRGOTExRUJBRUI2RUYzOEFBNzg5QTk1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoKDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgATQDIAwERAAIRAQMRAf/EAJcAAQACAwEBAAAAAAAAAAAAAAAEBQEGBwMCAQEAAwEBAQAAAAAAAAAAAAAAAQIDBAUGEAABAwQBAgQGAgICAwEAAAABAgMEABEFBhIhMVGREwdBceEiMlJhFIEVIzNCJEQIEQADAAECBAQEBQIFBQAAAAAAAQIDEQQhMUESUSIyE2FxgaGRscHRM/Dh8UJighRScpI0Bf/aAAwDAQACEQMRAD8A0pa18j9x7n4mvsj5gxzX+x86Ac1/sfOgHNf7HzoBzX+x86Ac1/sfOgHNf7HzoBzX+x86Ac1/sfOgHNf7HzoBzX+x86Ac1/sfOgNiZ0DcHtTXtbcUKwyEqcK/UHqlpBsp1LfxQLeN7dbWrB7nGsnt6+Y2WC3Hfp5TXea/2PnW5iOa/wBj50A5r/Y+dAOa/wBj50A5r/Y+dAOa/wBj50A5r/Y+dAOa/wBj50A5r/Y+dAOa/wBj50A5r/Y+dAZQtfIfce4+JoDC/wA1fM0BipIFAKAUAoBQCgFAKAusHpO2Z6DJnYbGOzYsQ8XXEFIuuwJQ2FFJWoAi4TWOTcY4aVPRs1jDdrWVqe7mL17AclbA8Mpkm7k4OA6PRaI+E2ai46fFti58VCqq7v0cF4v9F+rJ7Zj1cX4L9X+x0Y7zn4uEkaky1DYyEXB/7RcJMdP9dB5JfXjfRUSChMBVlXPIm5vXn/8AGh0snHR3pz4+Hd/5Hb79Kezhr26/2/A5ymFrGfSleHdbwWVX2xMt28B82/8Aklr/AOon4NvdPBVeh3XHq80+K5/Vfqji7Zvl5X4dPo/3PLMaNuGFxbWVy2KdhwXl+ml1ZQSlV7AOJSVFHL/xJ71OPc47rtl6si8FytWtEUdbmQoBQCgFAKAUAoBQGUfmn5ioJC/zV8zQGKkgUAoBQCgFAKAUAoDont17hbBr2obLGgpYcahNszIgfQVcHZMhDDl+JTySQeVvGvP3W1jJklvrw/Banbt9xURSXQsPbHSdB3XJvyyzIxasb6T0vBtuBcRalKKkradWPVDSihQU0rt8FWqm83GXDOnB69ev+PxL7bDjyPXlp06EnG5LStP908hP2SdMyOWfdfKn1wvRjMf2FdHU3Wpx1JbPphaE8ONVuMmXAlCSn58XoTNRjyt0238iBsUuFK9xctidf13FY/8AruLVkMvPj/2QwywkGRLLS1GO22B1TZH3G3xVV8UtYVV1T8Enp8l4lMjTyNTKXxf5+B9e43uTkM9pGKixkhvFT5MptS3EgSHWsc42llTgSEoQXCea0pT06AVG02ijI2/UkvuTudw6hJcn+hy+vTOAUAoBQCgFAKAUAoDKPzT8xUEhf5q+ZoDFSQKAUAoBQCgFAKAUBs2n4+fkcPtEHHx1yZkmPAaZaQO61zkWBV2SPiSew61zZ6U1Db0Sb/I3wy6mkvh+ZZ4nIPxtmwesaepM9MDINvZGW0TwyE0Hi+paxe0Zprm22D0tdXW4rO5TirycNVw/0rp9fE0imqURx0fH4v8AYv8APaVl9emHD7JIxsvQluOKhPZGUGXokdS/xhr6yUutoI+xIU2fCufHuJyLuhUsvXRc/n00+5teFw+2tPb6a/p1LX3a16CqAYmpOIl5ad6D+ww2nUuT5UWMyEsLU2TzUlBSlSkIT9xPIjpWexyvXXJwla9vgm+Zfd41ppHN8/FnMsshwaJqxUhaQZOWAKkqSL+s106j+DXox/Lfyk4b/jn/AHGv10GIoBQCgFAKAUAoBQGUfmn5ioJC/wA1fM0BipIFAKAUAoBQCgFAKA6T7be7WO1DXJuJl4hc5x95b7bjSkJDnqJCS29z7BNuhsenwrzt3snltUq0O3bbtY5aa1IsjLbjkGf7eobBIlw4tnV4aM21BnRAg3HKLHShEhtP7tch4pqyjHPDJKTfXmn9Xy+pDu3xiuHhya+nUkzZbm0ytc3DYHzJxWNxz72cBslAfxj/ABUylIslKpji2Bx+Nz4VWZ9pVjjhTfD/AHL9OJan7jm65Jcfp+/A11WDnvSlbPts1eB/2DyprakJP+zkOLJVyhxwUrSkdkuuFKQPGuj3El2Y13acP9K+b/Qx7Hr32+3Xj8fojad994cds+nN4FjFPsyC40pyTLW24UBlVwtKkfk4u33Gw7mubbbB48nc3+Btn3auO3Q5hXpHCKAUAoBQCgFAKAUBlH5p+YqCQv8ANXzNAYqSBQCgFAKAUAoBQCgFAfTTjrLzb7LimX2VBbLzaihxCh2UlSbFJ+VQ1rwZKeh1uF704pv28dx0mKt7bSlVpJYaLTkq/wDxzVr48OaLJV1Ty5D/ADXl1/8APr3dU/J8+ngegt4vb0a8/wDXE5LJkypclyXMfclS3jyekvKK3FnxUpVzXqJJLRcEee229XzPipIFAKAUAoBQCgFAKAUBlH5p+YqCQv8ANXzNAYqSCfIwGajYeLmn4i28VOUURJhKShxQ5XAAJUPwV3HwrNZZdOU/Mi7x0pVacGQK0KHtCiPzZseFHAVIlOoYZSo8QVuKCUgk9hc96rVJJt9CUtXoiTnsHksDl5GJyaEtzo3H1kNqDiRzSFpsod/tUKrjyK5VTyZa4cPR8yNChyp0xiFEbL0uU4lqOymwK1qNkpBJA6/zVqpStXyREpt6I+8ljZ+LnvY/IMKjTYxCX2FEEpJSFAEpJHZQPQ0i1S1XIVLl6PmRqsVLbWdVzuz5I47Cxw/IQj1XSpQbbbRe3Jaz2ueg8ayzZpxrWmaY8VW9JPHP4HJYDLPYnJpQiaylC1hpYcRxcTySQod7ipxZVc908iMmNw9HzK+tChOwuDy+cnjH4iKuZNKFOBlBSDwRbkq6ilPS4+NZ5MkwtaeiLxDp6JashyG3IzrzMhBaejrU2+2oWUhbZKVpI8QRV09eRVrQm5nAZrCOsM5aIqG7KaD7DayklTRNgqySq3XxqmPLN+l66Frx1PNaECtChJaxeUegP5FmI85joqgiTMSglptSrWStfYE8hVHcp6a8WWUtrXTgRquVFAKAUAoC1xOsZjK4vKZWGhv+hhkBzIPOuBHEKBUAkH8lWT2+VZXmmaUvnXI0jE6Ta5Iqq1MzKPzT8xUEhf5q+ZoDFSQdM2oLPsVpKUJ5rVMcShA7lSi+Ej/JNedh/wDZyfL9juy/wR8/3PrLYT2z0VUXE7Hj5WxbA6yh/Ilh0ssxg52S2Atu56G1+p7m17VEZM2bWoaienxFxixcKTqupFzGnYrCbRp+YwElcrXM9LjOwVPdXWlpdQpTSj3PRXS/XoQe1Wx56uLm1pcp6lbwqbmp9NNF/wC5Ev2txm/ZA7Dj5uZnS/SXNWy56TMJv0kpQEJStCnHOKeavmKw2k56xLsalLl8TbcPFOR9ybf5FLK0yLq3uxqjWPkKlYfJSoszGvL6rDanAChRsOVrgg+BrZbh5MF6rSkmmZPCozTpyemhYL17E7D/APoDL4rLNF+C6XHFthSkEqbjtFJ5IINZ+7WPaqp5/wB2X9tXuGny/sZ1nXPaHYcvN0+FFnt5NsPf1c865/2LZNl8W0q4hKT+KVJ+5P8ANM2XcY5WRtdv/SMePDbcJPXxPT2YcwcbA7kxMivryESK8MnIZc4JdjI9VIbZ+4FCxxX938jrUb9U6hp8G+HzJ2fapvVcepQa1q2k5t3M7K6mXjNGwbLRXDU4XZbrxRcthy6vtvbsb9QOlb5c2SO2ODyV+BljxRetcVEk/Ga/7c72xNg6xj5WvbHDYVIhsPOl5mShBsQq6l2NyAbWIvfrVLy5sLTtqof2LTjx5dVCc1+Zj2flnXtd23d1s+o5jo6IkVlfQKdUQtSLjxUW0030+5cYvF6jZvsmr8CZu2nw87vusZvFJ5YXcnGXXlJ7IdaAcf5W+K2UXP8AIVVNvncYrmvVj/r8y2bCryTS9NkrYMBC2/fNo2DLqkDWdZ9OAWISVOSJDrKerLISCR96zyt4jt1NVxZXixRE6d98ePJF8mNZMlU/TPAqZurapn9PzmTw2vT9WymBa/sJTMU6pmS1Yk3Llxysg9uxt3FazmuMkzVK1Xh0Mnii4bmXLk2CfkPb/Ae1GBhTsPNcgbCoTVwkPcHlOISlZdcXzT9qiEHiDbt0rCZy3npqlrPDU2qscYkmnpRp+X0eHK1bSJGAiFGZ2Z1xp661rTcAkEhRISlsAlRHwFdcbhq8it+WDnrAnEOVxos939r8UzltTw2qKLzuZDzUmdzLqVKjlAdkEXKQEDmSE9PhWW33lObrJ/l6fPoXzbZazMdT2k6T7dNuZXYHvXZ03ArGOQll1S5GTnoIDpSon7UBag2kItyIUbgVC3GZ6Qv5K4/9qJeDGtafonh82Ql4DQdu1fM5LVcfIwWZwLX9l6A66Xmn2LKUTcqX1shXUWsfEGr+7lxXKtqprqU9vHkhuF21J7wtK9vsf7c4PY9qdfYk5FwvqRHKzIkNKKi3HabvxSOHFS1/AfHrVa3GWs1RHJfb4llgxrGqvqXkLVpmV9slwNTg/wBRnb8qX0B25RGxrKgEqfWSo9UsDoCSSqwrGsynNrkevZP418PxNZxOsWkLTvf2OebgjRce2jDa625kZsY8chsTy1pS44k2WhhgHhxv05W/gX7134PdrzXwXSf3Zx5vbXlni/E1dH5p+YrpMAv81fM0BtmqYn26yuGejZzNO4HPpe5szHEhcVTFrBsDoL36q5EG/bpXLmvNNazPdP3N8UY6nSn219iz9xNl1xOva9qWrTFT4mBV/Ycyik2St8XKePQcvuUpRt07Cs9rhvvrJa0ddDTcZJ7ZiHr29Sx2B/299wHo2fl7CjWM2WUMZaHJaLiVen2WySUg97DqbjuAazxLLgThT3z0L5Hjy+Z1211IWx7jrj+Y1DC4Rak6xq8hg/7B8FJdUHEeo9Yi/BKUk9utz07VfFgtTdV67XIpkzS3Mz6ZLXdYntTuG2SsonbU4oKDaJ6VtckSEoQB6kVwkC/H7FdD1Hbxz29Z8WNT2d3h8PmaZliyXr3af10K7P73gcp7laxKhKMfWtdcjx2JLoIu02sFx0g/cE2SAL9el/jV8W2qcNp+u9SmTPNZZa9MkzEbdrUf31n7E9kGkYR1Lobnnl6aiphtAt0v+SSO1VvBb2yjTzeH1LRllZ3WvlKH2vz2Hw/uUMtk5SIuNH93/wBld+P/ACqPp9gT91bbzFV4e2Vq+Bltskzl1b4cSVoOx4LGsb2mfNbjnKxX28aF3/5lrU+UhFh8eae/jVdziqnj0Xpa1+xbBkme/V81w+5E9utnwETD5nU9mU4xhM8hB/vNAqVGfQAApQAJ4/ak3sbEdehq+6w26nJHqnp4ldvllS4r00XmCm6H7eibmMdsCNn2B5hcbFsRm/TaaDhBLjpusD8Rfr/AHWsMk5c+kueyeprFY8OtKu6uhS5DP4eN7Q4vW4UxMjKzZyp+bbRcKbN1LSlfS3UhA/xW04qe4dteVLRGVZEsKlPi3qzZPZ/3MwmDwM3FbA6hAx61TMGpwFV1OJUFsoNjxVyJt/CjXPvtpV0qjrwZvtNzMy1XTkVnt5vENOuZrXsrmntcm5KUcjDzrIJCH3CkuNukfAlPx6EE9Qa03W3ffNzPektNDPb512uW+1t66lfu+ZkN4VMCPv8AL2Z+WVN5GK2FJiegR25km6r/AAv5W66bfGu7V41GnLxK5rfbordfkW3utk9JzuLxORw+eS67jobUKNgktn1BdSea3CSOHBAsRb4dKy2UZIpqp5vXUvuqiknNclpoSonuJgsT7S4mNBebd3GI2/EiJFy5DTIcUHH/AAH/ABAcf5I/mq1tarO2/wCN6P56dCy3EzhSXr/INe4mCxHtNiYmNfQ5uDUReNbKbl2G08u7rhJ6AlCE28VW/mj2tVnbf8euvzH/ACJnEkvXpp8io1LNalk/b9/RthyBwqmZX93F5QpK2eV+XBz+QSruRcHvcVrnx5Jy+7C7uGjRniuKx+3T046pn3Ly+o6tqmQ1vWsp/ucvsPBjK5wILUePGP2KS33vZKldie5JPYVE48mW1drtmeS6tku4xw5l9zrmyD7u7FiszmMdCwMlMjD4eA3Dhvov6ZWrotQvb8UpQD8qvscVRLdLzU9Sm7yKqSnkkbTmPdhjC5vVcbrWQTI1fDMsIyf9dNkvmxacBJAJDbf32/aubHsnc3Vrz1rodF7tTUqX5VzND9xTr7m45CXr8tuZi5yhKQtq4Shxz/tbsQm33gq/zXdte/20rWlLgcm47e9uXqma6j80/MVuYmVhPI9T3Pw+tAYsjxPl9aAWR4ny+tALI8T5fWgFkeJ8vrQCyPE+X1oBZHifL60AsjxPl9aAWR4ny+tALI8T5fWgFkeJ8vrQCyPE+X1oBZHifL60AsjxPl9aAWR4ny+tALI8T5fWgFkeJ8vrQCyPE+X1oBZHifL60AsjxPl9aAWR4ny+tALI8T5fWgFkeJ8vrQCyPE+X1oDKAnkOp7j4fWgP/9k=";

  const date = new Date().toDateString().substr(3, 7);
  let year = new Date().getFullYear();
  const startYValue = 23;

  let pdfDoc = new jsPDF();

  pdfDoc.setFontSize(20);
  pdfDoc.setFont("Helvetica", "normal");
  var width = pdfDoc.internal.pageSize.getWidth();

  pdfDoc.setFont("Helvetica", "normal");
  pdfDoc.text(width / 2, startYValue / 2, title, { align: "center" });
  pdfDoc.setFontSize(12);
  pdfDoc.setFont("Helvetica", "normal");
  pdfDoc.text(209, 20, `Date: ${date}, ${year}`, { align: "right" });
  pdfDoc.addImage(imgData, "JPG", 1, 1);

  autoTable(pdfDoc, {
    startY: startYValue,
    font: "Helvetica",
    head: [pdfHeaders],
    headStyles: { fillColor: [38, 97, 167] },
    body: fileData,
    margin: { top: 15, left: 0, right: 0, bottom: 5 },
  });

  pdfDoc.save(fileName);
};

export const FREE_JOB_POSTING_STM_THRESHOLD = 200;

export const timerDelay = 5000;

//Dashboard -> For Activity List
export const activityListPerPage = 10;
export const recentActivityPerPage = 3;
export const recentMessagesPerPage = 3;
export const recentPublicResumePerPage = 5;
export const recentJobsPerPage = 3;

//Oraganizaion -> Group Leader Group Category
export const groupCategoryPerPage = 10;

//GroupLeader -> JobSeeker List
export const groupLeaderJSPerPage = 10;
export const groupLeaderRecentJSPerPage = 3;

//GroupLeader -> SupportTeamMember List
export const groupLeaderSTMPerPage = 10;
export const groupLeaderRecentSTMPerPage = 3;

//GroupLeader -> Job List
export const groupLeaderJobsPerPage = 9;
export const groupLeaderRecentJobsPerPage = 3;
//Employer -> Job List
export const employerJobsPerPage = 9;
export const employerResumesPerPage = 9;

//GroupLeader -> Job List
export const groupLeaderAbuseReportsPerPage = 10;

//Support Team Member -> Sponsorship List
export const supportSponsorshipsPerPage = 10;
export const supportRecentSponsorshipsPerPage = 7;
//Support Team Member -> Connection List
export const supportConnectionsPerPage = 10;
//Job Seeker -> Connection List
export const jobseekerConnectionsPerPage = 10;
export const jobseekerNetworkPerPage = 10;
export const jobseekerStmCount = 5;

//JobSeeker -> My Resumes
export const jobSeekerResumesPerPage = 10;

//Messages
export const messagesPerPage = 10;

//Admin
export const allUserPerPage = 10;

export const sortParamsForJob = [
  "Newest First",
  "Oldest First",
  "Company Name Ascending",
  "Company Name Descending",
  "Industry Ascending",
  "Industry Descending",
  "City Ascending",
  "City Descending",
  "State Ascending",
  "State Descending",
];

export const sortParamsForResumes = [
  "Newest First",
  "Oldest First",
  "Job title Ascending",
  "Job title Descending",
  "Name Ascending",
  "Name Descending",
];

export const sortParamsForPrivateResumes = [
  "Newest First",
  "Oldest First",
  "Job Title Ascending",
  "Job Title Descending",
  "Name Ascending",
  "Name Descending",
  "City Ascending",
  "City Descending",
  "State Ascending",
  "State Descending",
];

export const sortParamsForJobJS = [
  ...sortParamsForJob,
  "Position Title Ascending",
  "Position Title Descending",
];

export const connectionResponses = {
  contactMe: 1,
  helpFullInformation: 2,
  notAwareOfOpportunity: 3,
};

export const ProfanitiesWordKeysToReplace = [
  "!",
  ".",
  '"',
  "'",
  "|",
  ",",
  "/",
  "\\",
  "<",
  ">",
  "?",
  ":",
  ";",
  "“",
  "”",
  "(",
  ")",
  "[",
  "]",
  "{",
  "}",
];

export const helpful = "Here is helpful information";
export const helpfulText = "Here is some information that may be helpful:";

export const sitekey = "6LdEtoQmAAAAAAWa9B0-avnsG0aZ0YD3fqaokeS7";

//For Api
export const loginAPI = `${process.env.REACT_APP_API_GATEWAY_URL}/connect/token`;
export const reportFailedLogginAPI = `${process.env.REACT_APP_FAILED_LOGIN_LOGGER}`;

//For Api
export const API_URL = `${process.env.REACT_APP_API_GATEWAY_URL}/api/`;
export const API_DEMO_PRESENTATION_URL = `${process.env.REACT_APP_API_DEMO_PRESENTATION_URL}/`;

export const logoutAPI = `${process.env.REACT_APP_API_GATEWAY_URL}/connect/endsession`;

export const employerRequestAPI = API_URL + `Employer/CreateUpdateSignUp`;
export const jobseekerRequestAPI = API_URL + `JobSeeker/CreateUpdateSignUp`;
export const supportTeamRequestAPI =
  API_URL + `SupportTeamMember/CreateUpdateSignUp`;
export const groupLeaderRequestAPI =
  API_URL + `AffiliateGroupLeader/CreateUpdateSignUp`;

export const getEmployer =
  API_URL +
  `AffiliateGroupLeader/GetAffiliateGroupLeader?AffiliateGroupLeaderId=1`;

export const publicResumeRootUrl = `${process.env.REACT_APP_PUB_FILE_URL}Resumes/`;

export const fileResumeTitle = (resumePath, resumeName) => {
  // The resumePath is always in the format [File ID]_[Orignale File Name]
  const fileName = resumePath.split("_")[1];

  // If the resumeName is a frendly name (Professional Title) then create a frendly title containing both the file name and the frendly name
  if (fileResumeHasProfessionalTitle(resumeName)) {
    return `${fileName} (${resumeName})`;
  }

  // If the resumeName is not a frendly name (Professional Title) then just return the file name
  return fileName;
};

export const fileResumeHasProfessionalTitle = (resumeName) => {
  // If resumeName has a '.' in it, then it is most lickly a file name (old database setup) and not a not a frendly name.
  return resumeName && !resumeName.includes(".");
};
